var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
var SvgUser = function (props) { return (_jsx("svg", __assign({ width: 25, height: 26, viewBox: "0 0 25 26", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: _jsx("path", { d: "M12.5 6.75a2.09 2.09 0 0 1 2.083 2.083 2.09 2.09 0 0 1-2.083 2.083 2.09 2.09 0 0 1-2.083-2.083A2.09 2.09 0 0 1 12.5 6.75Zm0 10.416c2.813 0 6.042 1.344 6.25 2.084H6.25c.24-.75 3.448-2.084 6.25-2.084Zm0-12.5a4.166 4.166 0 0 0-4.167 4.167A4.165 4.165 0 0 0 12.5 13a4.165 4.165 0 0 0 4.167-4.167A4.165 4.165 0 0 0 12.5 4.666Zm0 10.417c-2.781 0-8.333 1.396-8.333 4.167v2.083h16.666V19.25c0-2.771-5.552-4.167-8.333-4.167Z", fill: "#fff" }) }))); };
var Memo = memo(SvgUser);
export default Memo;
//# sourceMappingURL=User.js.map